import React from 'react';
import { Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { ShareAltOutlined } from '@ant-design/icons';
import Header from '../WizardHeader';
import Button from '../../Button';
import Link from '../../Link';
import WizardInput from '../Input';
import ShareModal from '../../TinyComponents/ShareModal';
import localStyles from './styles.less';

const FinishView = ({
  locale,
  createdCourse,
  createdSchool,
  t,
  translitString,
  translate,
  page,
}) => {
  const [shareModalOpen, setShareModalOpen] = React.useState(false);
  const handleShareClicked = () => {
    setShareModalOpen(!shareModalOpen);
  };

  const course = { ...createdCourse };
  course.school = createdSchool;
  course.link = translitString(course.title, true);
  course.school.link = translitString(course.school.Name, true);

  return (
    <WizardInput>
      <div className={localStyles.finishedStep}>
        <h2>{t('course.create.wizard.congratulations')}</h2>
        <h3>{t('course.create.wizard.congratulations.text.2')}</h3>
      </div>
      <div className={`${localStyles.header}`}>
        <Header
          translitString={translitString}
          t={t}
          translate={translate}
          locale={locale}
          page={page}
          course={createdCourse}
          school={createdSchool}
        />
        <div className={localStyles.shareInfo}>{t('course.create.wizard.congratulations.text')}</div>
        <div className={localStyles.buttonContainer}>
          <Tooltip color="white" title={t('course.share.tooltip')} placement="bottom">
            <Button onClick={() => setShareModalOpen(true)} version="large" type="primary">
              <ShareAltOutlined />
              <span>{t('school.edit.toolbar.share')}</span>
            </Button>
          </Tooltip>
        </div>
        <ShareModal onCancel={handleShareClicked} visible={shareModalOpen} course={course} />
        <Link route="index" locale={locale} className={localStyles.homePageLink}>
          {t('back.home.page')}
        </Link>
      </div>
    </WizardInput>
  );
};

FinishView.propTypes = {
  locale: PropTypes.string,
  t: PropTypes.func,
  translitString: PropTypes.func,
  translate: PropTypes.func,
  page: PropTypes.string,
  createdCourse: PropTypes.object.isRequired,
  createdSchool: PropTypes.object.isRequired,
};

FinishView.defaultProps = {
  locale: '',
  t: () => { },
  translitString: () => { },
  translate: () => { },
  page: '',
};

export default FinishView;
